// extracted by mini-css-extract-plugin
export default {"container":"NavbarTemplate_container__v4rv1"};